import { Directive, HostListener } from '@angular/core';
import { NgxIntlTelInputComponent } from 'ngx-intl-tel-input';
import { formatPhoneNumber } from '../../../../app/utils/common.utils';

@Directive({
  selector: '[formControlName][phoneMask]'
})
export class SharedPhoneMaskDirective {
  constructor(private telInput: NgxIntlTelInputComponent) {}
  

  @HostListener('input', ['$event'])
  onKeyDown(event) {
    const input = event?.target as HTMLInputElement;
    const countryCode = this.telInput.selectedCountry?.dialCode;
    input.value =
      input.value && event?.srcElement?.id === 'phone'
        ? this.onPhoneMaskFormat(`+${countryCode} ${input?.value}`, this.telInput.selectedCountry?.iso2, `+${countryCode}`)
        : input?.value;
  }

  onPhoneMaskFormat(value: string, countryISO?, countryCode?: string): string {
    return formatPhoneNumber(value, countryISO, countryCode);
  }
}
